var render = function render(){var _vm=this,_c=_vm._self._c;return _c('full-page-vue',{attrs:{"isMobile":_vm.isMobile,"pagination":_vm.fullpagePagination}},[_c('main-video-2024'),_c('main-sodam'),_c('main-selfdx'),_c('main-fullpage-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }